/* eslint-disable @next/next/no-img-element */
import React, { useState } from 'react';
import ContainerHome24 from '../../atoms/ContainerHome24';
import WhiteButton from '../../atoms/WhiteButton/WhiteButton';
import Styles from './CarrosEletricosHeroMesAmbiente.css';
import RedButton from '@/components/atoms/RedButton';

function CarrosEletricosHeroMesAmbiente() {
  const [width, setWidth] = useState(typeof window === 'undefined' ? 0 : window.window.innerWidth);

  if (typeof window === 'undefined') {
    console.log('');
  } else {
    window.addEventListener('resize', function () {
      setWidth(window.window.innerWidth);
    });
  }
  return (
    <>
      <section id="hero-santander-financiamentos">
        <div className="bg-hero">
          {typeof window === 'undefined' ? (
            <></>
          ) : (
            <>
              {width <= 450 && (
                <picture>
                  <source
                    type="image/png"
                    srcSet="assets/mes-do-ambiente/carros-eletricos/banner-320.png"
                  />
                  <img
                    src="assets/mes-do-ambiente/carros-eletricos/banner-320.png"
                    alt="Banner promocional de financiamento sustentável com veículo elétrico. Na Santander Financiamento você possui facilidades para adquirir um carro híbrido ou elétrico com condições especiais no Mês do Meio Ambiente."
                    className=""
                  />
                </picture>
              )}
              {width > 450 && width <= 799 && (
                <picture>
                  <source
                    type="image/png"
                    srcSet="assets/mes-do-ambiente/carros-eletricos/banner-450.png"
                  />
                  <img
                    src="assets/mes-do-ambiente/carros-eletricos/banner-450.png"
                    alt="Banner promocional de financiamento sustentável com veículo elétrico. Na Santander Financiamento você possui facilidades para adquirir um carro híbrido ou elétrico com condições especiais no Mês do Meio Ambiente."
                    className=""
                  />
                </picture>
              )}
              {width > 799 && width <= 993 && (
                <picture>
                  <source
                    type="image/png"
                    srcSet="assets/mes-do-ambiente/carros-eletricos/banner-800.png"
                  />
                  <img
                    src="assets/mes-do-ambiente/carros-eletricos/banner-800.png"
                    alt="Banner promocional de financiamento sustentável com veículo elétrico. Na Santander Financiamento você possui facilidades para adquirir um carro híbrido ou elétrico com condições especiais no Mês do Meio Ambiente."
                    className=""
                  />
                </picture>
              )}
              {width > 993 && width <= 1280 && (
                <picture>
                  <source
                    type="image/png"
                    srcSet="assets/mes-do-ambiente/carros-eletricos/banner-992.png"
                  />
                  <img
                    src="assets/mes-do-ambiente/carros-eletricos/banner-992.png"
                    alt="Banner promocional de financiamento sustentável com veículo elétrico. Na Santander Financiamento você possui facilidades para adquirir um carro híbrido ou elétrico com condições especiais no Mês do Meio Ambiente."
                    className=""
                  />
                </picture>
              )}
              {width > 1280 && width <= 1360 && (
                <picture>
                  <source
                    type="image/png"
                    srcSet="assets/mes-do-ambiente/carros-eletricos/banner-1280.png"
                  />
                  <img
                    src="assets/mes-do-ambiente/carros-eletricos/banner-1280.png"
                    alt="Banner promocional de financiamento sustentável com veículo elétrico. Na Santander Financiamento você possui facilidades para adquirir um carro híbrido ou elétrico com condições especiais no Mês do Meio Ambiente."
                    className=""
                  />
                </picture>
              )}
              {width > 1360 && width <= 1920 && (
                <picture>
                  <source
                    type="image/png"
                    srcSet="assets/mes-do-ambiente/carros-eletricos/banner-1360.png"
                  />
                  <img
                    src="assets/mes-do-ambiente/carros-eletricos/banner-1360.png"
                    alt="Banner promocional de financiamento sustentável com veículo elétrico. Na Santander Financiamento você possui facilidades para adquirir um carro híbrido ou elétrico com condições especiais no Mês do Meio Ambiente."
                    className=""
                  />
                </picture>
              )}
              {/* {width > 1360 && width <= 1440 && (
                <picture>
                  <source
                    type="image/png"
                    srcSet="assets/mes-do-ambiente/carros-eletricos/banner-1440.png"
                  />
                  <img
                    src="assets/mes-do-ambiente/carros-eletricos/banner-1440.png"
                    alt="Banner promocional de financiamento sustentável com veículo elétrico. Na Santander Financiamento você possui facilidades para adquirir um carro híbrido ou elétrico com condições especiais no Mês do Meio Ambiente."
                    className=""
                  />
                </picture>
              )} */}
              {width > 1920 && width <= 2650 && (
                <picture>
                  <source
                    type="image/png"
                    srcSet="assets/mes-do-ambiente/carros-eletricos/banner-1920.png"
                  />
                  <img
                    src="assets/mes-do-ambiente/carros-eletricos/banner-1920.png"
                    alt="Banner promocional de financiamento sustentável com veículo elétrico. Na Santander Financiamento você possui facilidades para adquirir um carro híbrido ou elétrico com condições especiais no Mês do Meio Ambiente."
                    className=""
                  />
                </picture>
              )}
              {width > 2650 && (
                <picture>
                  <source
                    type="image/png"
                    srcSet="assets/mes-do-ambiente/carros-eletricos/banner-2650.png"
                  />
                  <img
                    src="assets/mes-do-ambiente/carros-eletricos/banner-2650.png"
                    alt="Banner promocional de financiamento sustentável com veículo elétrico. Na Santander Financiamento você possui facilidades para adquirir um carro híbrido ou elétrico com condições especiais no Mês do Meio Ambiente."
                    className=""
                  />
                </picture>
              )}
            </>
          )}
        </div>
        <ContainerHome24>
          <div className="hero-contain">
            <div className="hero-buttons">
              <RedButton
                href="https://www.cliente.santanderfinanciamentos.com.br/originacaocliente/?int_source=SF&int_medium=carros-eletricos:banner&int_campaign=simular#/dados-pessoais"
                id="simular-banner-mobile"
                target="_blank"
                rel="noopener"
              >
                Simular
              </RedButton>
              {/* <RedButton href="#santander-carousel" id="hero-button-outros-produtos">
                Produtos
              </RedButton> */}
            </div>
          </div>
        </ContainerHome24>
        <style jsx>{Styles}</style>
      </section>
    </>
  );
}

export default CarrosEletricosHeroMesAmbiente;
